import ENDPOINTS from '../../constants/apiEndPoints';
import {UsersGroupFormValues} from '../../pages/users/components/GroupScreens/components/AddEditGroupDialog';
import {
  GroupQueryParams,
  GroupsListResponse,
  SingleGroupResponse,
} from '../../pages/users/components/GroupScreens/groups';
import {ApiResponse, axiosInstance} from '../axiosInstance';

export const handleCreateUserGroupService = async (
  payload: UsersGroupFormValues,
) => {
  const response = await axiosInstance.post(
    ENDPOINTS.GET_CREATE_USER_GROUP,
    payload,
  );
  return response?.data;
};

export const handleGetAllUserGroupsService = async (
  params: GroupQueryParams,
): Promise<ApiResponse<GroupsListResponse>> => {
  const response = await axiosInstance.get(ENDPOINTS.GET_CREATE_USER_GROUP, {
    params,
  });
  return response?.data;
};

export const handleGetUserGroupService = async (
  id: string,
): Promise<ApiResponse<SingleGroupResponse>> => {
  const response = await axiosInstance.get(
    ENDPOINTS.GET_UPDATE_DELETE_USER_GROUP(id),
  );
  return response?.data;
};

export const handleUpdateUserGroupService = async (
  id: string,
  payload: UsersGroupFormValues,
) => {
  const response = await axiosInstance.put(
    ENDPOINTS.GET_UPDATE_DELETE_USER_GROUP(id),
    payload,
  );
  return response?.data;
};

export const handleDeleteUserGroupService = async (id: string) => {
  const response = await axiosInstance.delete(
    ENDPOINTS.GET_UPDATE_DELETE_USER_GROUP(id),
  );
  return response?.data;
};
